// Canonical country list (ISO short names, Danish). Focus markets on top.
export const COUNTRY_GROUPS = [
  {
    label: "Fokus",
    countries: [
      "Pakistan", "Danmark", "Storbritannien", "Norge", "Sverige", "Tyskland",
      "Canada", "USA", "Nederlandene", "Belgien", "Frankrig", "Italien",
      "Spanien", "Australien", "Forenede Arabiske Emirater", "Saudi-Arabien",
    ],
  },
  {
    label: "Sydasien",
    countries: ["Indien", "Bangladesh", "Afghanistan", "Sri Lanka", "Nepal", "Bhutan", "Maldiverne"],
  },
  {
    label: "Mellemøsten & Nordafrika",
    countries: [
      "Tyrkiet", "Egypten", "Marokko", "Algeriet", "Tunesien", "Libanon", "Jordan",
      "Syrien", "Irak", "Iran", "Palæstina", "Yemen", "Oman", "Qatar", "Kuwait", "Bahrain",
      "Libyen", "Sudan",
    ],
  },
  {
    label: "Sydøstasien & Østasien",
    countries: ["Indonesien", "Malaysia", "Singapore", "Filippinerne", "Thailand", "Kina", "Japan", "Sydkorea"],
  },
  {
    label: "Afrika syd for Sahara",
    countries: ["Nigeria", "Somalia", "Etiopien", "Kenya", "Tanzania", "Uganda", "Sydafrika", "Senegal", "Ghana", "Elfenbenskysten"],
  },
  {
    label: "Europa (øvrige)",
    countries: [
      "Finland", "Island", "Polen", "Tjekkiet", "Slovakiet", "Østrig", "Schweiz",
      "Portugal", "Grækenland", "Bosnien-Hercegovina", "Albanien", "Kosovo",
      "Nordmakedonien", "Bulgarien", "Rumænien", "Ukraine", "Kroatien",
    ],
  },
  {
    label: "Nord- & Sydamerika",
    countries: ["Mexico", "Brasilien", "Argentina", "Chile", "Colombia", "Peru", "Venezuela"],
  },
  {
    label: "Oceanien",
    countries: ["New Zealand", "Fiji"],
  },
  {
    label: "Centralasien & Kaukasus",
    countries: ["Aserbajdsjan", "Kasakhstan", "Usbekistan", "Turkmenistan", "Kirgisistan", "Tadsjikistan", "Georgien", "Armenien"],
  },
];

export const ALL_COUNTRIES = COUNTRY_GROUPS.flatMap((g) => g.countries);

// Deal-breaker keys must match backend DEAL_BREAKERS in utils.py
export const DEAL_BREAKER_OPTIONS = [
  { key: "same_sect",       label: "Samme sekt / madhhab",         hint: "Kun match hvis kandidatens sekt er blandt dine præferencer" },
  { key: "verified_only",   label: "Kun verificerede profiler",     hint: "Skjul uverificerede kandidater" },
  { key: "same_heritage",   label: "Fælles baggrund/ophav",          hint: "Kun kandidater med mindst ét fælles oprindelsesland" },
  { key: "shared_language", label: "Fælles sprog",                   hint: "Mindst ét fælles talt sprog" },
  { key: "halal_lifestyle", label: "Halal-livsstil",                 hint: "Kandidaten skal leve halal" },
  { key: "non_smoker",      label: "Ikke-ryger",                     hint: "Skjul rygere" },
  { key: "no_alcohol",      label: "Ingen alkohol",                  hint: "Skjul kandidater der drikker" },
  { key: "prays_five",      label: "Beder 5 gange dagligt",          hint: "Kandidaten skal opretholde salah" },
  { key: "wears_hijab",     label: "Bærer hijab",                    hint: "Kun for søstre — kun kandidater der bærer hijab" },
  { key: "keeps_beard",     label: "Bærer skæg",                     hint: "Kun for brødre — kun kandidater med skæg" },
  { key: "wants_children",  label: "Ønsker børn",                    hint: "Kun kandidater der ønsker børn" },
  { key: "no_children_yet", label: "Ingen børn endnu",               hint: "Kun kandidater uden eksisterende børn" },
  { key: "never_married",   label: "Aldrig gift før",                hint: "Kun aldrig-gifte kandidater" },
];
